import { VoiceStyleOptionIdType } from '@/pages/Onboarding/options/VoiceStyle/types.ts';
import { VOICE_STYLE_OPTIONS } from '@/pages/Onboarding/options/VoiceStyle/VOICE_STYLE_OPTIONS.ts';

const DEFAULT_ID: VoiceStyleOptionIdType = 'deep_hypnotic';
const DEFAULT_TITLE = VOICE_STYLE_OPTIONS[0].title;

export const getVoiceStyleIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): VoiceStyleOptionIdType | null => {
  const id = VOICE_STYLE_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }

  if (withDefault) {
    return DEFAULT_ID;
  }

  return null;
};

export const getVoiceStyleTitleById = (
  id: VoiceStyleOptionIdType | null | undefined,
  withDefault = false,
): string | null => {
  const title = VOICE_STYLE_OPTIONS.find((option) => option.id === id)?.title;

  if (title) {
    return title;
  }

  if (withDefault) {
    return DEFAULT_TITLE;
  }

  return null;
};
